import React from "react";
import { useOutletContext, Link } from "react-router-dom";

const SalesQtyByMonth = () => {
  const { salesQtyByMonthHistoricallyObject, loading, error, niceMoney, formatNumber } = useOutletContext();

  if (loading) return <p>Loading…</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  const rows = salesQtyByMonthHistoricallyObject?.salesByMonth || [];

  return (
    <div>
      <p><Link to="/Portal">← Back to Client Portal</Link></p>
      <h2>Sales by Month</h2>

      <table style={{ margin: "0 auto", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ borderBottom: "1px solid #ccc", padding: "0.25rem 0.75rem" }}>Month</th>
            <th style={{ borderBottom: "1px solid #ccc", padding: "0.25rem 0.75rem" }}>Sales</th>
            <th style={{ borderBottom: "1px solid #ccc", padding: "0.25rem 0.75rem" }}>Qty</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.month}>
              <td style={{ borderBottom: "1px solid #eee", padding: "0.25rem 0.75rem" }}>{r.month}</td>
              <td style={{ borderBottom: "1px solid #eee", padding: "0.25rem 0.75rem" }}>{niceMoney(r.sales)}</td>
              <td style={{ borderBottom: "1px solid #eee", padding: "0.25rem 0.75rem" }}>{formatNumber(r.qty)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}


export default SalesQtyByMonth;
